import { CompleteVehicleEntry, Features, FeaturesText, Picture } from '@oneaudi/vtp-shared';
import { AudiFeatureAppTyreLabelTyreLabelItem } from './TyreLabel';

export type TyreLabels =
  | {
      mainTyreLabels: AudiFeatureAppTyreLabelTyreLabelItem[];
      additionalTyreLabels: AudiFeatureAppTyreLabelTyreLabelItem[];
    }
  | undefined;
export interface SplitEquipments {
  withImages: Features[];
  rest: Features[];
}

export const splitEquipments = (equipments: Features[]) => {
  const splittedEquipments: SplitEquipments = { withImages: [], rest: [] };
  equipments.forEach((feature) => {
    if (feature.texts) {
      if (feature.images) {
        const image = getValueByKey<Picture>(feature.images, 'small_hd_image');
        if (image) {
          splittedEquipments.withImages.push(feature);
          return;
        }
      }
      splittedEquipments.rest.push(feature);
    }
  });
  return splittedEquipments;
};

export function getValueByKey<T extends { key: string }>(
  array: T[] | undefined,
  key: string
): T | undefined {
  if (!array) {
    return undefined;
  }
  return array.find((value) => value.key === key);
}

export const decodeHtmlEntities = (input: FeaturesText | string | undefined): string => {
  if (!input) return '';
  const inputToDecode = typeof input !== 'string' ? input.text : input;
  if (typeof window !== 'undefined' && typeof DOMParser !== 'undefined') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(inputToDecode, 'text/html');
    return doc.documentElement.textContent || '';
  }
  return '';
};

export const isTyre = (prno: string): boolean =>
  prno.includes('RAD') || prno.includes('REI') || prno.includes('ZBR');

export const getTyreLabelLinks = (vehicleData: CompleteVehicleEntry): TyreLabels => {
  const { tyreLabels } = vehicleData.basic;

  if (!tyreLabels) {
    return undefined;
  }

  const tyreRegEx = /(RAD|REI)/gi;

  const tyreLabelItem = tyreLabels.find((tyreLabel) => {
    if (tyreLabel.prNumber.match(tyreRegEx)) {
      return tyreLabel;
    }
    return undefined;
  });

  const additionalTyrelabelItems = tyreLabels.filter(
    (tyreLabel) => !tyreLabel.prNumber.match(tyreRegEx)
  );

  if (!tyreLabelItem && additionalTyrelabelItems.length === 0) {
    return undefined;
  }

  let mainTyreLabels: AudiFeatureAppTyreLabelTyreLabelItem[] = [];
  const additionalTyreLabels: AudiFeatureAppTyreLabelTyreLabelItem[] = [];

  if (tyreLabelItem && tyreLabelItem.labels) {
    mainTyreLabels = tyreLabelItem.labels.map<AudiFeatureAppTyreLabelTyreLabelItem>((label) => {
      return { tyreLabelUrl: label.tyreLabelUrl, productSheetUrl: label.productSheetUrl };
    });
  }
  if (additionalTyrelabelItems.length > 0) {
    additionalTyrelabelItems.forEach((additionalTyreLabelItem) => {
      if (!additionalTyreLabelItem.labels) {
        return;
      }
      additionalTyreLabelItem.labels.forEach((label) => {
        additionalTyreLabels.push({
          tyreLabelUrl: label.tyreLabelUrl,
          productSheetUrl: label.productSheetUrl,
        });
      });
    });
  }

  return { mainTyreLabels, additionalTyreLabels };
};
